import { Plus, Inbox } from "lucide-react";
import { ItemRow } from "@/components/quote/ItemRow";
import { useAuth } from "@/context/AuthContext";
import { isStaff } from "@/lib/staffView";

const HEADS = [
  ["#", "w-[40px]"], ["Drawing", "w-[66px]"], ["Mark", "w-[96px]"], ["Location", "min-w-[110px]"], ["Type", "w-[200px]"], ["W (in)", "w-[84px] text-right"],
  ["H (in)", "w-[84px] text-right"], ["Qty", "w-[56px] text-right"], ["Sq ft", "w-[64px] text-right"],
  ["Cost", "w-[96px] text-right"], ["Suggested", "w-[100px] text-right"], ["Item price", "w-[96px] text-right"],
  ["Line total", "w-[150px] text-right"], ["", "w-[72px]"],
];

export function ItemsTable({ rows, types, onPatch, onType, onDelete, onAdd, emptyNote, company, doorItems, onPick }) {
  const staff = isStaff(useAuth().user);
  const heads = staff ? HEADS.filter(([h]) => h !== "Cost") : HEADS;
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-800 bg-[#F2F2F7]/60">
      <div className="overflow-x-auto">
        <table className="qi-table w-full min-w-[1340px] border-collapse" data-testid="quote-items-table">
          <thead>
            <tr className="border-b border-slate-800 bg-slate-900/60">
              {heads.map(([h, cls]) => (
                <th key={h || "x"} className={`px-3 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500 ${cls}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <ItemRow key={r.id} row={r} idx={i} types={types} company={company} onPatch={(p) => onPatch(r.id, p)}
                doorItems={doorItems} onPick={(c) => onPick(r.id, c)}
                onType={(tid) => onType(r.id, tid)} onDelete={() => onDelete(r.id)} />
            ))}
          </tbody>
        </table>
      </div>
      {rows.length === 0 && (
        <div data-testid="items-empty-state" className="flex flex-col items-center px-6 py-14 text-center">
          <Inbox className="mb-3 h-7 w-7 text-slate-600" />
          <p className="text-sm text-slate-400">{emptyNote || "No items yet. Add your first window or door."}</p>
        </div>
      )}
      <div className="flex items-center justify-between border-t border-slate-800 px-4 py-3">
        <button data-testid="add-quote-item-button" onClick={onAdd}
          className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-amber-300 transition-colors hover:bg-amber-500/10">
          <Plus className="h-4 w-4" /> Add row
        </button>
        <span className="text-xs text-slate-500">Open a row's specs (chevron) to edit model, frame, glass, colors, hardware and rough opening.</span>
      </div>
    </div>
  );
}
